import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_ENDPOINTS } from "../../../util/constants";
import * as helpers from "../../../util/helpers";
import {
  createHeadersWithAuth,
  createQueryString,
  requestPromise,
} from "../../../util/request";

import {
  actions as dashActions,
  LOADING_STATES,
} from "../../Dashboard/_redux/dashboardRedux";

export const actionTypes = {
  CallSummary: "[Insights] CallSummary Action",
  CallSummarySuccess: "[Insights] CallSummary Success Action",
  CallPickupTime: "[Insights] CallPickupTime Action",
  CallPickupTimeSuccess: "[Insights] CallPickupTime Success Action",
  CallConnectivity: "[Insights] CallConnectivity Action",
  CallConnectivitySuccess: "[Insights] CallConnectivity Success Action",
  CallConnectivityCompare: "[Insights] CallConnectivityCompare Action",
  CallConnectivityCompareSuccess:
    "[Insights] CallConnectivityCompare Success Action",
  CallConnectivityCompareReset:
    "[Insights] CallConnectivityCompare Reset Action",
  AgentInsightsDetails: "[Insights] AgentInsightsDetails Action",
  AgentInsightsDetailsSuccess: "[Insights] AgentInsightsDetails Success Action",
  AgentInsightsDetailsFailure: "[Insights] AgentInsightsDetails Failure Action",
  SelectedAgent: "[Insights] Selected Agent Action",
  SelectedAgentSuccess: "[Insights] Selected Agent Success Action",
  AgentInsightsHandelingTime: "[Insights] AgentInsightsHandelingTime Action",
  AgentInsightsHandelingTimeSuccess:
    "[Insights] AgentInsightsHandelingTime Success Action",
  AgentInsightsHandelingTimeFailure:
    "[Insights] AgentInsightsHandelingTime Failure Action",
  AgentListings: "[Insights] AgentListings Action",
  AgentListingsSuccess: "[Insights] AgentListings Success Action",
  AgentInboundCallDetails: "[Insights] AgentInboundCallDetails Action",
  AgentInboundCallDetailsSuccess:
    "[Insights] AgentInboundCallDetails Success Action",
  AgentInboundCallDetailsFailure:
    "[Insights] AgentInboundCallDetails Failure Action",
  AgentOutboundCallDetails: "[Insights] AgentOutboundCallDetails Action",
  AgentOutboundCallDetailsSuccess:
    "[Insights] AgentOutboundCallDetails Success Action",
  AgentOutboundCallDetailsFailure:
    "[Insights] AgentOutboundCallDetails Failure Action",
};

const initialInsightsState = {
  callSummary: null,
  callConnectivity: null,
  callConnectivityCompare: null,
  status: 0,
  agentInsightsDetails: null,
  selectedAgent: null,
  agentInsightsHandelingTime: null,
  agentListings: null,
  agentInboundCallDetails: null,
  agentOutboundCallDetails: null,
};

export const actions = {
  callSummary: (payload) => ({ type: actionTypes.CallSummary, payload }),
  callSummarySuccess: (payload) => ({
    type: actionTypes.CallSummarySuccess,
    payload,
  }),
  callPickupTime: (payload) => ({ type: actionTypes.CallPickupTime, payload }),
  callPickupTimeSuccess: (payload) => ({
    type: actionTypes.CallPickupTimeSuccess,
    payload,
  }),
  callConnectivity: (payload) => ({
    type: actionTypes.CallConnectivity,
    payload,
  }),
  callConnectivitySuccess: (payload) => ({
    type: actionTypes.CallConnectivitySuccess,
    payload,
  }),
  callConnectivityCompare: (payload) => ({
    type: actionTypes.CallConnectivityCompare,
    payload,
  }),
  callConnectivityCompareSuccess: (payload) => ({
    type: actionTypes.CallConnectivityCompareSuccess,
    payload,
  }),
  callConnectivityCompareReset: (payload) => ({
    type: actionTypes.CallConnectivityCompareReset,
    payload,
  }),
  agentInsightsDetails: (payload) => ({
    type: actionTypes.AgentInsightsDetails,
    payload,
  }),
  agentInsightsDetailsSuccess: (payload) => ({
    type: actionTypes.AgentInsightsDetailsSuccess,
    payload,
  }),
  agentInsightsDetailsFailure: (payload) => ({
    type: actionTypes.AgentInsightsDetailsFailure,
    payload,
  }),
  selectedAgent: (payload) => ({ type: actionTypes.SelectedAgent, payload }),
  selectedAgentSuccess: (payload) => ({
    type: actionTypes.SelectedAgentSuccess,
    payload,
  }),
  agentInsightsHandelingTime: (payload) => ({
    type: actionTypes.AgentInsightsHandelingTime,
    payload,
  }),
  agentInsightsHandelingTimeSuccess: (payload) => ({
    type: actionTypes.AgentInsightsHandelingTimeSuccess,
    payload,
  }),
  agentInsightsHandelingTimeFailure: (payload) => ({
    type: actionTypes.AgentInsightsHandelingTimeFailure,
    payload,
  }),
  agentListings: (payload) => ({ type: actionTypes.AgentListings, payload }),
  agentListingsSuccess: (payload) => ({
    type: actionTypes.AgentListingsSuccess,
    payload,
  }),
  agentInboundCallDetails: (payload) => ({
    type: actionTypes.AgentInboundCallDetails,
    payload,
  }),
  agentInboundCallDetailsSuccess: (payload) => ({
    type: actionTypes.AgentInboundCallDetailsSuccess,
    payload,
  }),
  agentInboundCallDetailsFailure: (payload) => ({
    type: actionTypes.AgentInboundCallDetailsFailure,
    payload,
  }),
  agentOutboundCallDetails: (payload) => ({
    type: actionTypes.AgentOutboundCallDetails,
    payload,
  }),
  agentOutboundCallDetailsSuccess: (payload) => ({
    type: actionTypes.AgentOutboundCallDetailsSuccess,
    payload,
  }),
  agentOutboundCallDetailsFailure: (payload) => ({
    type: actionTypes.AgentOutboundCallDetailsFailure,
    payload,
  }),
};

export const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-module-insights";
};
export const reducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: ["callSummary", "callConnectivity"],
  },
  (state = initialInsightsState, action) => {
    switch (action.type) {
      case "[Auth] Logout Action": {
        return initialInsightsState;
      }
      case actionTypes.CallSummarySuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, callSummary: action.payload.success };
        }
        return { ...state, callSummary: null };
      }
      case actionTypes.CallPickupTimeSuccess: {
        if (action.payload && action.payload.s === 200) {
          return { ...state, callPickupTime: action.payload };
        }
        return { ...state, callPickupTime: null };
      }

      case actionTypes.CallConnectivitySuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, callConnectivity: action.payload.success };
        }
        return { ...state, callConnectivity: null };
      }

      case actionTypes.CallConnectivityCompareSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, callConnectivityCompare: action.payload.success };
        }
        return { ...state, callConnectivityCompare: null };
      }

      case actionTypes.CallConnectivityCompareReset: {
        return { ...state, callConnectivityCompare: null };
      }

      case actionTypes.AgentInsightsDetailsSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, agentInsightsDetails: action.payload.success };
        }
        return { ...state, agentInsightsDetails: { msg: "No Details Found" } };
      }

      case actionTypes.SelectedAgentSuccess: {
        return { ...state, selectedAgent: action.payload };
      }

      case actionTypes.AgentInsightsHandelingTimeSuccess: {
        if (action.payload && action.payload.status === 200) {
          return {
            ...state,
            agentInsightsHandelingTime: action.payload.success,
          };
        }
        return {
          ...state,
          agentInsightsHandelingTime: { msg: "No Details Found" },
        };
      }

      case actionTypes.AgentListingsSuccess: {
        if (action.payload && action.payload.objects.length > 0) {
          return { ...state, agentListings: action.payload.objects };
        }
        return { ...state, agentListings: null };
      }

      case actionTypes.AgentInboundCallDetailsSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, agentInboundCallDetails: action.payload.success };
        }
        return {
          ...state,
          agentInboundCallDetails: { msg: "No Details Found" },
        };
      }

      case actionTypes.AgentOutboundCallDetailsSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, agentOutboundCallDetails: action.payload.success };
        }
        return {
          ...state,
          agentOutboundCallDetails: { msg: "No Details Found" },
        };
      }

      case actionTypes.AgentInsightsDetailsFailure: {
        return { ...state, agentInsightsDetails: { msg: "No Details Found" } };
      }

      case actionTypes.AgentInsightsHandelingTimeFailure: {
        return {
          ...state,
          agentInsightsHandelingTime: { msg: "No Details Found" },
        };
      }

      case actionTypes.AgentInboundCallDetailsFailure: {
        return {
          ...state,
          agentInboundCallDetails: { msg: "No Details Found" },
        };
      }

      case actionTypes.AgentOutboundCallDetailsFailure: {
        return {
          ...state,
          agentOutboundCallDetails: { msg: "No Details Found" },
        };
      }

      default:
        return state;
    }
  }
);

export function* postCallSummary(action) {
  yield put(
    dashActions.setLoadingState({
      resource: LOADING_STATES.call_distribution,
      loading_state: "loading",
    })
  );

  yield put({ type: "loading_state", payload: { loading_state: "loading" } });
  let requestURL = API_ENDPOINTS.getCallSummary;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callSummarySuccess(response, options.method));
    yield put(
      dashActions.setLoadingState({
        resource: LOADING_STATES.call_distribution,
        loading_state: "loaded",
      })
    );
    if (helpers.isAgent()) {
      yield put(dashActions.setLoadingState({ loading_state: "loaded" }));
    }
  } catch (error) {}
}

export function* postCallPickupTime(action) {
  yield put(
    dashActions.setLoadingState({
      resource: LOADING_STATES.call_insights,
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getCallPickupTime;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  try {
    const response = yield call(requestPromise, requestURL, options);
    yield put(actions.callPickupTimeSuccess(response, options.method));
    yield put(
      dashActions.setLoadingState({
        resource: LOADING_STATES.call_insights,
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

export function* postCallConnectivity(action) {
  yield put(
    dashActions.setLoadingState({
      resource: LOADING_STATES.call_connectivity,
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getCallConnectivity;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callConnectivitySuccess(response, options.method));
    yield put(
      dashActions.setLoadingState({
        resource: LOADING_STATES.call_connectivity,
        loading_state: "loaded",
      })
    );
  } catch (error) {}

  yield put({ type: "loading_state", payload: { loading_state: "loaded" } });
}

export function* postCallConnectivityCompare(action) {
  yield put(
    dashActions.setLoadingState({
      resource: LOADING_STATES.call_connectivity,
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getCallConnectivity;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";

  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callConnectivityCompareSuccess(response, options.method));
    yield put(
      dashActions.setLoadingState({
        resource: LOADING_STATES.call_connectivity,
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

export function* postAgentInsightsDetails(action) {
  let requestURL = API_ENDPOINTS.getAgentInsightsDetails;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  try {
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.agentInsightsDetailsSuccess(response, options.method));
  } catch (error) {
    yield put(actions.agentInsightsDetailsFailure(null, options.method));
  }
}

export function* getSelectedAgent(action) {
  yield put(actions.selectedAgentSuccess(action.payload));
}

export function* postAgentInsightsHandelingTime(action) {
  let requestURL = API_ENDPOINTS.getAgentInsightsHandelingTime;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  try {
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(
      actions.agentInsightsHandelingTimeSuccess(response, options.method)
    );
  } catch (error) {
    yield put(actions.agentInsightsHandelingTimeFailure(null, options.method));
  }
}

export function* postAgentListings(action) {
  let requestURL = API_ENDPOINTS.getAgentsListingsForAdmin;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.agentListingsSuccess(response, options.method));
  } catch (error) {}
}

export function* postAgentInboundDetails(action) {
  let requestURL = API_ENDPOINTS.getAgentInboundDetails;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  try {
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.agentInboundCallDetailsSuccess(response, options.method));
  } catch (error) {
    yield put(actions.agentInboundCallDetailsFailure(null, options.method));
  }
}

export function* postAgentOutboundDetails(action) {
  let requestURL = API_ENDPOINTS.getAgentInboundDetails;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "POST";
  options.body = JSON.stringify(action.payload);
  try {
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(
      actions.agentOutboundCallDetailsSuccess(response, options.method)
    );
  } catch (error) {
    yield put(actions.agentOutboundCallDetailsFailure(null, options.method));
  }
}

export function* saga() {
  yield takeLatest(actionTypes.CallSummary, postCallSummary);
  yield takeLatest(actionTypes.CallPickupTime, postCallPickupTime);
  yield takeLatest(actionTypes.CallConnectivity, postCallConnectivity);
  yield takeLatest(
    actionTypes.CallConnectivityCompare,
    postCallConnectivityCompare
  );
  yield takeLatest(actionTypes.AgentInsightsDetails, postAgentInsightsDetails);
  yield takeLatest(actionTypes.SelectedAgent, getSelectedAgent);
  yield takeLatest(
    actionTypes.AgentInsightsHandelingTime,
    postAgentInsightsHandelingTime
  );
  yield takeLatest(actionTypes.AgentListings, postAgentListings);
  yield takeLatest(
    actionTypes.AgentInboundCallDetails,
    postAgentInboundDetails
  );
  yield takeLatest(
    actionTypes.AgentOutboundCallDetails,
    postAgentOutboundDetails
  );
}
